"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringValidator = void 0;
const google_libphonenumber_1 = require("google-libphonenumber");
const utils_1 = require("./utils");
const validator_1 = require("./validator");
const phoneNumberUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
const PATTERN_DATE = /^\d{4}-\d{2}-\d{2}$/;
const PATTERN_TIME = /^\d{2}:\d{2}(:\d{2})?$/;
const PATTERN_DATE_TIME = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/;
const PATTERN_ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3,6}Z?$/;
const PATTERN_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]+$/;
const PATTERN_STAMP_NUMBER = /^\d{5}(\/\d)?$/;
class StringValidator extends validator_1.CommonValidator {
    merge(props) {
        return new StringValidator({ ...this.props, ...props });
    }
    minLength(minLength) {
        return this.merge({ minLength });
    }
    maxLength(maxLength) {
        return this.merge({ maxLength });
    }
    pattern(pattern) {
        return this.merge({ pattern });
    }
    format(format) {
        return this.merge({ format });
    }
    date() {
        return this.format("date");
    }
    time() {
        return this.format("time");
    }
    dateTime() {
        return this.format("date-time");
    }
    email() {
        return this.format("email");
    }
    phoneNumber() {
        return this.format("phone-number");
    }
    stampNumber() {
        return this.format("stamp-number");
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [
                this.validateType,
                this.validateMinLength,
                this.validateMaxLength,
                this.validatePattern,
                this.validateFormat
            ]
        });
    };
    validateType = async ({ ctx, next }) => {
        if (typeof ctx.value === "string") {
            return next();
        }
        ctx.addError({ type: "string" });
    };
    validateMinLength = async ({ rootCtx, ctx, next }) => {
        const minLength = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.minLength);
        if (minLength === undefined || ctx.value.length >= minLength) {
            return next();
        }
        ctx.addError({ minLength });
    };
    validateMaxLength = async ({ rootCtx, ctx, next }) => {
        const maxLength = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.maxLength);
        if (maxLength === undefined || ctx.value.length <= maxLength) {
            return next();
        }
        ctx.addError({ maxLength });
    };
    validatePattern = async ({ rootCtx, ctx, next }) => {
        const pattern = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.pattern);
        if (pattern === undefined) {
            return next();
        }
        if (new RegExp(pattern).test(ctx.value)) {
            return next();
        }
        ctx.addError({ pattern });
    };
    validateFormat = async ({ rootCtx, ctx, next }) => {
        const format = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.format);
        if (format === "date") {
            return this.validateDate(ctx, next);
        }
        if (format === "time") {
            return this.validateTime(ctx, next);
        }
        if (format === "date-time") {
            return this.validateDateTime(ctx, next);
        }
        if (format === "email") {
            return this.validateEmail(ctx, next);
        }
        if (format === "phone-number") {
            return this.validatePhoneNumber(ctx, next);
        }
        if (format === "stamp-number") {
            return this.validateStampNumber(ctx, next);
        }
        return next();
    };
    validateDate = async (ctx, next) => {
        if (PATTERN_DATE.test(ctx.value)) {
            return next();
        }
        ctx.addError({ format: "date" });
    };
    validateTime = async (ctx, next) => {
        if (PATTERN_TIME.test(ctx.value)) {
            return next();
        }
        ctx.addError({ format: "time" });
    };
    validateDateTime = async (ctx, next) => {
        if (PATTERN_DATE_TIME.test(ctx.value) ||
            PATTERN_ISO_DATE_TIME.test(ctx.value)) {
            return next();
        }
        ctx.addError({ format: "date-time" });
    };
    validateEmail = async (ctx, next) => {
        if (PATTERN_EMAIL.test(ctx.value)) {
            return next();
        }
        ctx.addError({ format: "email" });
    };
    validatePhoneNumber = async (ctx, next) => {
        try {
            if (phoneNumberUtil.isValidNumber(phoneNumberUtil.parse(ctx.value))) {
                return next();
            }
        }
        catch {
            // Ignore parsing errors, validation will fail below
        }
        ctx.addError({ format: "phone-number" });
    };
    validateStampNumber = async (ctx, next) => {
        if (PATTERN_STAMP_NUMBER.test(ctx.value)) {
            return next();
        }
        ctx.addError({ format: "stamp-number" });
    };
    isEmptyValue(value) {
        return value === undefined || value === null || value === "";
    }
}
exports.StringValidator = StringValidator;
